import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Instructional Design Review of Stile"
      description="Conducted by Johns Hopkins University's Centre for Research and Reform in Education"
      slug={props.location.pathname}
    />
  );
}

function JohnsHopkinsPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Instructional Design Review of Stile"
        subtitle="Conducted by Johns Hopkins University's Centre for Research and Reform in Education"
        id="JOHNS_HOPKINS"
        redirectUrl="https://stileapp.com/go/john-hopkins-report"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/johns_hopkins.png"
            alt=""
          />
        }
      >
        <p>
          In June 2024, Alan J. Reid (PhD) and Steve Ross (PhD) from Johns Hopkins University’s
          Centre for Research and Reform in Education completed a design review using a broad
          sampling of curricula developed by Stile for middle and high school aged learners. These
          materials included access to the digital platform, course samples, lesson plans, and
          teacher guides. This evaluation considers the learning products collectively from an
          instructional design perspective that investigates their program design framework, content
          selection, design, and development, evaluation, and material interface.
        </p>
        <p>
          The researchers at Johns Hopkins University found the curriculum to be grounded in
          rigorous research and had a meticulously designed logic model. Download the review to read
          through their analysis yourself!
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default JohnsHopkinsPage;
